import { toast } from 'sonner';

/**
 * Exora signature notification system.
 * Symbol-prefix design: [◇] neutral, [✓] confirmed, [—] removed, [!] error
 */
export const exoraToast = {
  /** [◇] Default / neutral / info */
  neutral: (message: string) => {
    toast(message, {
      icon: '◇',
      duration: 4000,
    });
  },

  /** [✓] Confirmed / success actions */
  success: (message: string) => {
    toast(message, {
      icon: '✓',
      duration: 3000,
    });
  },

  /** [—] Removal / clearing */
  remove: (message: string) => {
    toast(message, {
      icon: '—',
      duration: 3000,
    });
  },

  /** [!] Errors */
  error: (message: string) => {
    toast(message, {
      icon: '!',
      duration: 5000,
    });
  },

  /** Push notification foreground toast */
  push: ({ title, body, duration = 6000, onClick }: {
    title: string;
    body?: string;
    duration?: number;
    onClick?: () => void;
  }) => {
    toast(title, {
      icon: '◇',
      description: body,
      duration,
      ...(onClick ? { action: { label: '→', onClick } } : {}),
    });
  },
};
